import {
  IMockProps,
  ErrorResponseCodeType,
  Mocks,
  MockServiceType,
  BussinessErrorLocalType,
} from '../../Core';
import { CODE_ERRORS, ENDPOINT_API_PATH } from '../../Apis/CountriesApi';
import { CountriesServiceRequestType } from '../../Types/Countries.types';
import { COUNTRIES } from '../../Mocks/CountriesMocksDef';

type ParamsType = {
  country: string;
  ddi: string;
  iso2: string;
  iso3: string;
};

const COUNTRY = 'Brasil';

/** Mocks de Sucesso */
const mocksSuccess: IMockProps[] = [];

/** Mocks de Erro */
let mocksErrors: IMockProps[] = [];

const objBRA = {
  iso3: 'BRA',
  country: 'Brasil',
  countryToSave: 'Brazil',
  ddi: '55',
  iso2: 'BR',
};

const otherCountries = COUNTRIES;
otherCountries.push(objBRA);

const generateSuccess = (params?: ParamsType | undefined): IMockProps => {
  const validateDocumentSuccess: IMockProps = {
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: params ? objBRA : otherCountries,
    },
  };
  if (params !== null) {
    validateDocumentSuccess.configRequest.params = params;
  }
  return validateDocumentSuccess;
};

mocksSuccess.push(
  generateSuccess({
    country: 'Brasil',
    ddi: '55',
    iso2: 'BR',
    iso3: 'BR',
  }),
);

mocksSuccess.push(generateSuccess());

const generateDefaultErrors = (country: string): IMockProps[] => {
  return CODE_ERRORS.map(
    (
      error: ErrorResponseCodeType<BussinessErrorLocalType>,
      index: number,
    ): IMockProps => {
      return {
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          params: {
            country: `${country}${index}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };
    },
  );
};

mocksErrors = mocksErrors.concat(generateDefaultErrors(COUNTRY));

export const mocksService: MockServiceType<CountriesServiceRequestType>[] =
  mocksSuccess.map((request) => {
    return {
      label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
      value: request.configRequest.params,
    };
  });

const allMocks: IMockProps[] = mocksSuccess.concat(mocksErrors);

Mocks.getInstance().addAll(allMocks);
